import { APIHelper } from '@archistarai/auth-frontend';

export default {
  async show(siteGuid: string) {
    return APIHelper.ManageAPI.get(`site-details/${siteGuid}`);
  }
};
